import './peaks.css'
import React, {useEffect, useLayoutEffect} from 'react';
import {CaptionListProps} from '../../types/caption';
import {BLUE_COLOR, INACTIVE_COLOR, usePeaksjs} from '../../helper/usePeaksjs';
import {v4 as uuidv4} from 'uuid';
import {PeaksInstance, Segment, SegmentAddOptions, SegmentDragEvent, SegmentMouseEvent, WaveformColor} from 'peaks.js';
import {audioRefAtom} from "../../states/timeline";
import {useAtom} from "jotai";
import {setExport2txt} from '../../helper/axiosPost';
import {modalState, saveState} from '../../states/action';
import {secondsToFormattedTime, timeStringToSeconds} from '../../helper/util'
import {AIcaptionListState, captionListState} from '../../states/caption';
import { MINIMUM_CAPTION_GAP } from '../../env-var/env-var';
import { captionSelectionModeState, currentActivatedSegmentAtom, initializeState, initializeUrlState, reactPlayerAtom } from 'src/states/initialize';
import { findNextSegment } from 'src/helper/peaksUtils';

declare global {
  var peaksInstance: PeaksInstance | undefined
  var latestClickedTime: number | undefined
  var previousSegment: Segment | undefined
  var currentTime: number | undefined
  var isAutoCaptionHighlight : boolean | undefined
}

function useGlobalState() {
    const [isAutoCaptionHighlight, setIsAutoCaptionHighlight] = useAtom(captionSelectionModeState)
    const [{uploadCaptionUrl, setCaptionUrl}] = useAtom(initializeUrlState)
    const [audioRefGlobal, setAudioRefGlobal] = useAtom(audioRefAtom)
    const [{job_id, user_id, caption_max_time, caption_min_time}] = useAtom(initializeState);
    const [{needSaveOn}, setSave] = useAtom(saveState);
    const [captionList, setCaptionList] = useAtom(captionListState);
    const [AICaptionList] = useAtom(AIcaptionListState);
    const [currentActivatedSegment, setCurrentActivatedSegment] = useAtom(currentActivatedSegmentAtom)
    const [reactPlayerGlobal, setReactPlayerGlobal] = useAtom(reactPlayerAtom)
    return {isAutoCaptionHighlight,
            setIsAutoCaptionHighlight,
            uploadCaptionUrl,
            setCaptionUrl,
            audioRefGlobal,
            setAudioRefGlobal,
            job_id,
            user_id,
            caption_max_time,
            caption_min_time,
            needSaveOn,
            setSave,
            captionList,
            AICaptionList,
            setCaptionList,
            currentActivatedSegment,
            setCurrentActivatedSegment,
            reactPlayerGlobal,
          }
}

function PeaksComponent() {

  const {
    nextAfterActivatedSegmentRef,
    currentActivatedSegmentRef,
    zoomIn,
    zoomOut,
    zoomviewWaveformRef,
    audioElementRef,
    segments,
    setSegments,
    peaksInstance,
    mp3Url,
    captionArr,
    setCaptionArr,
  } = usePeaksjs()

  const {isAutoCaptionHighlight,
    setIsAutoCaptionHighlight,
    uploadCaptionUrl,
    setCaptionUrl,
    audioRefGlobal,
    setAudioRefGlobal,
    job_id,
    user_id,
    caption_max_time,
    caption_min_time,
    needSaveOn,
    setSave,
    captionList,
    AICaptionList,
    setCaptionList,
    currentActivatedSegment,
    setCurrentActivatedSegment,
    reactPlayerGlobal
  } = useGlobalState()


    useEffect(() => {
      window.addEventListener("keydown", keyDownListener);
      return () => {
        window.removeEventListener("keydown", keyDownListener);
      }
    }, [keyDownListener]);

    useEffect(() => {
      setAudioRefGlobal(audioElementRef)
    }, []);

  useLayoutEffect(() => {
    if(! globalThis.peaksInstance) return
    globalThis.peaksInstance.segments.getSegments().map((segment, i) => {
       if(i === 0) return
        const foundCaption = captionList.find(v => v.id === segment.id)
        if(!foundCaption) {
          alert('에러 : 캡션을 찾을 수 없음')
          return
        }
        const firstline = segment.labelText!.split("\n\n").slice(0,1)
        segment.update({endTime : foundCaption.endTime as number , startTime : foundCaption.startTime as number , labelText : `${firstline}\n\n${foundCaption.caption}`})
    })

  }, [captionList]);

  function saveCaption() {
    setCaptionArr((prev) => {
      setExport2txt(uploadCaptionUrl, setCaptionUrl, job_id, user_id, prev, AICaptionList, setSave)
      return prev
    })
  }

  function turnOffCurrentHighlightedSegment(currentSegment : CaptionListProps) {
      if(!peaksInstance) {
        alert("peaksInstance is not defined")
        return
      }
      const peaksSegment = peaksInstance.segments.getSegment(currentSegment.id!)
      if(!peaksSegment) {
        alert("peaksSegment is not defined")
        return
      }
      peaksSegment.update({color : INACTIVE_COLOR})
      const customEvent = new CustomEvent('customRemove', { detail: { segmentId: currentSegment.id , type : "mouseclick" } });
      document.dispatchEvent(customEvent);
  }

  function highlightNextSegment({currentCaption, nextAfterActivatedSegmentRef}
                              : {currentCaption  : CaptionListProps, nextAfterActivatedSegmentRef: React.MutableRefObject<Segment | undefined>}) {

    // nextAfterActivatedSegmentRef

    setCaptionList(prevCaptionList => {
      if(!peaksInstance) {
          alert("peaksInstance is not defined")
          return prevCaptionList
      }


      const nextId = parseInt(currentCaption.id!) + 1


      const willBeHighlightingSegment = peaksInstance.segments.getSegments().find(v => parseInt(v.id!) === nextId)
      if(!willBeHighlightingSegment) {
        // alert("활성화할 세그먼트가 없습니다")
        return prevCaptionList
      }

      const willBeHighlightingCaption = prevCaptionList.find(v =>  willBeHighlightingSegment.id === v.id )
      // const willBeHighlightingCaption = prevCaptionList.find(v =>  willBeHighlightingSegment.startTime === v.startTime! )
      // const willBeHighlightingSegment = prevCaptionList.find(v =>  currentCaption.startTime! < v.startTime! )
      // if(!willBeHighlightingSegment) {
      //   // alert("다음 캡션이 없습니다.")
      //   return prevCaptionList
      // }

      // const peaksSegment = peaksInstance.segments.getSegment(willBeHighlightingSegment.id!)
      // const peaksSegment = willBeHighlightingSegment
      // if(!peaksSegment) {
      //   alert("peaksSegment is not defined")
      //   return prevCaptionList
      // }

      willBeHighlightingSegment.update({color : BLUE_COLOR})
      currentActivatedSegmentRef.current = willBeHighlightingCaption
      // currentActivatedSegment

      if(willBeHighlightingCaption) {

        setCurrentActivatedSegment(willBeHighlightingCaption)
      }

      // const nextSegment = findNextSegment({peaksInstance, currentSegment : willBeHighlightingSegment})
      // if(nextSegment) {
      //   nextAfterActivatedSegmentRef.current = nextSegment
      // } else {
      //   alert("다음 세그먼트가 없습니다")
      // }

      // setCurrentActivatedSegment(nextCaption)
      const customEvent = new CustomEvent('custom', { detail: { segmentId: willBeHighlightingSegment.id , type : "mouseclick" } });
      document.dispatchEvent(customEvent);

      return prevCaptionList
    })
  }

  function seekToNext(currentCaption : CaptionListProps) {
    setCaptionList(prevCaptionList => {
      if(!reactPlayerGlobal) {
        alert("reactPlayerGlobal is not defined")
        return prevCaptionList
      }
      if(!peaksInstance) {
        alert("peaksInstance is not defined")
        return prevCaptionList
      }

      const nextCaption = prevCaptionList.find(v =>  currentCaption.startTime! < v.startTime! )
      if(!nextCaption) {
        // alert("다음 캡션이 없습니다.")
        return prevCaptionList
      }

      setCurrentActivatedSegment(nextCaption)

      const nextStartTime = (nextCaption.startTime!) as number
      if(nextStartTime < 1 &&  nextStartTime !== 0) {

        let nextStartTimeModified = nextStartTime / 100;

        reactPlayerGlobal.current?.seekTo(nextStartTimeModified,"fraction") ;
        peaksInstance.player.seek(nextStartTimeModified)
      } else {
        reactPlayerGlobal.current?.seekTo(nextStartTime,"fraction") ;
        peaksInstance.player.seek(nextStartTime)
      }

      const nextSegment = peaksInstance.segments.getSegment(nextCaption.id!)
      // nextSegment.


      return prevCaptionList
    })
  }

  function keyDownListener(event: KeyboardEvent) {

    // const [{modalOn}, setModalOn] = useAtom(modalState);


    if(event.target  instanceof HTMLInputElement) return

    // event.target
    // Ctrl + S 인식
    if (event.ctrlKey && event.keyCode === 83) {
      event.preventDefault()
      saveCaption()
    }

    // event.target
    // Ctrl + F 인식 (찾기)
    if (event.ctrlKey && event.keyCode === 70) {
      event.preventDefault()
    }

    // event.target
    // Ctrl + G 인식 (이동)
    if (event.ctrlKey && event.keyCode === 70) {
      event.preventDefault()
    }

    // event.target
    // Ctrl + D 인식 (검수)
    if (event.ctrlKey && event.keyCode === 70) {
      event.preventDefault()
    }


    if(event.target instanceof Node &&
      ((event.target as HTMLElement).classList.contains('modified_input_text')
      || (event.target as HTMLElement).classList.contains('search_input')))
    {return}



    function setSegmentToCurrentTime({type , ignoreOverlap } : {type : "start" | "end", ignoreOverlap : boolean}) {

        if(!globalThis.peaksInstance) return ;
        const currentTime = globalThis.peaksInstance.player.getCurrentTime()
        const currentActivatedSegment = currentActivatedSegmentRef.current
        if(! currentActivatedSegment){
          alert('캡션을 찾을수 없음')
          return
        }

        setCaptionList(prevCaptionList => {

          if(type === "start") {

              const targetSegment = globalThis.peaksInstance!.segments.getSegment(currentActivatedSegment.id!)!
              const duration = targetSegment.endTime - targetSegment.startTime
              const endTime =  currentTime <= (currentActivatedSegment.endTime as number) ? targetSegment.endTime : currentTime + duration
              targetSegment.update({startTime : currentTime, endTime})
              const segments = globalThis.peaksInstance!.segments.getSegments()
              segments.sort((a,b) => a.startTime - b.startTime)

              segments.map((segment, index) => {
                const [firstLine, secondLine] = segment.labelText!.split("\n\n")
                const [firstLineHeader, firstLineRest] = firstLine.split(" ")
                const newFirstLine = `#${index} ${firstLineRest}`
                segment.update({labelText : `${newFirstLine}\n\n${secondLine}`})
              })

              const renewedCaptionList  = prevCaptionList.map((caption, index) => {
                if(caption.id === currentActivatedSegment.id) {
                  const duration = caption.endTime as number - (caption.startTime as number)
                  const endTime =  currentTime <= (currentActivatedSegment.endTime as number) ? caption.endTime : currentTime + duration
                  return {...caption, startTime : currentTime, time_ini : secondsToFormattedTime(currentTime), endTime, }
                } else {
                  return {...caption}
                }
              })
              renewedCaptionList.sort((a, b) => a.startTime! as number - (b.startTime! as number))


              if(currentActivatedSegmentRef.current) {
                const newActivatedSegment = {...currentActivatedSegmentRef.current, startTime : currentTime as Number, endTime : endTime as Number}
                currentActivatedSegmentRef.current = newActivatedSegment

                setCurrentActivatedSegment(newActivatedSegment)
              }

              return renewedCaptionList.map((caption, index) => {
                return {
                  ...caption,
                  seq : index,
                }
              })

          } else if(type === "end" ){

            const targetSegment = globalThis.peaksInstance!.segments.getSegment(currentActivatedSegment.id!)!
            const duration = targetSegment.endTime - targetSegment.startTime
            const startTime =  currentTime >= (currentActivatedSegment.startTime as number) ? targetSegment.startTime : currentTime - duration
            targetSegment.update({startTime : startTime, endTime : currentTime})
            const segments = globalThis.peaksInstance!.segments.getSegments()
            segments.sort((a,b) => a.startTime - b.startTime)

            segments.map((segment, index) => {
              const [firstLine, secondLine] = segment.labelText!.split("\n\n")
              const [firstLineHeader, firstLineRest] = firstLine.split(" ")
              const newFirstLine = `#${index} ${firstLineRest}`
              segment.update({labelText : `${newFirstLine}\n\n${secondLine}`})
            })


            const renewedCaptionList  = prevCaptionList.map((caption, index) => {
              if(caption.id === currentActivatedSegment.id) {
                // const duration = caption.endTime as number - (caption.startTime as number)
                // const startTime =  currentTime >= (currentActivatedSegment.startTime as number) ? caption.startTime : currentTime -duration
                return {...caption, startTime, endTime : currentTime, time_end : secondsToFormattedTime(currentTime)}
              } else {
                return {...caption}
              }
            })
            renewedCaptionList.sort((a, b) => a.startTime! as number - (b.startTime! as number))

            // globalThis.peaksInstance!.segments.getSegment(currentActivatedSegment.id!)?.update({endTime : currentTime})
            if(currentActivatedSegmentRef.current) {
                const newActivatedSegment = {...currentActivatedSegmentRef.current, startTime : startTime as Number, endTime : currentTime as Number}
                currentActivatedSegmentRef.current = newActivatedSegment
                setCurrentActivatedSegment(newActivatedSegment)


            }
            return renewedCaptionList.map((caption, index) => {
              return {
                ...caption,
                seq : index,
              }
            })

          } else return prevCaptionList
        })


        return currentActivatedSegment
    }

    const Q_KEY = 81
    if (event.keyCode === Q_KEY) {
        event.preventDefault()
        setSegmentToCurrentTime({type : "start" , ignoreOverlap : false})
    }

    const W_KEY = 87
    if (event.keyCode === W_KEY) {
      event.preventDefault()
      setSegmentToCurrentTime({type : "end" , ignoreOverlap : false})
    }

    const R_KEY = 82
    if (event.keyCode === R_KEY) {
      event.preventDefault()
      const currentSegment =  setSegmentToCurrentTime({type : "end" , ignoreOverlap : true})
      if(!currentSegment) {
        alert('캡션을 찾을수 없음')
        return
      }
      turnOffCurrentHighlightedSegment(currentSegment)

      highlightNextSegment({currentCaption :  currentSegment, nextAfterActivatedSegmentRef})
      // seekToNext(currentSegment)
      // find next segment
      // go to found segment's start position
    }

    const DELETE_KEY_CODE = 46
    if (event.keyCode === DELETE_KEY_CODE) {
      event.preventDefault()
      deleteSegment()
    }

    // Tab 키 인식
    const TAB_KEYCODE = 9
    if (event.keyCode === TAB_KEYCODE) {
      event.preventDefault()
      if (audioElementRef.current && peaksInstance) {
        audioElementRef.current.paused
          ? audioElementRef.current.play()
          : audioElementRef.current.pause()
      }
    }
  }

  const addSegment: React.MouseEventHandler<HTMLButtonElement> = e => {

    e.preventDefault()
    if (peaksInstance == null) return

    const currentTime = peaksInstance.player.getCurrentTime();

    const findCurrentSegment = (caption: CaptionListProps, index: number) => {
      if (Number(caption.startTime) <= currentTime && Number(caption.endTime) >= currentTime) {
        return true
      } else return false
    }

    const findCurrentSegmentIdx = (caption: CaptionListProps, index: number) => {
      if (Number(caption.startTime) <= currentTime
        && Number(caption.endTime) >= currentTime) {
        return true
      } else return false
    }

    const foundSegment = captionArr.find(findCurrentSegment)
    const foundIdx = captionArr.findIndex(findCurrentSegmentIdx);

    if (foundSegment) {

      const nextSegemnt = captionArr.find(caption => foundSegment.seq + 1 === caption.seq)

      if (nextSegemnt) {
        const addedSegmentEndtimeThreshold = (foundSegment.endTime as number) + MINIMUM_CAPTION_GAP + 0.5 + MINIMUM_CAPTION_GAP
        if (addedSegmentEndtimeThreshold >= (nextSegemnt.startTime as number)) {
          alert('추가할 자막이 다른 자막과 겹침니다')
          return;
        }
      }

      const firstHalf = captionArr.slice(0, foundIdx + 1).map((caption, index) => {
        return {
          ...caption,
          seq: Number(caption.seq)
        }
      })

      const secondHalf = captionArr.slice(foundIdx + 1).map((caption, index) => {
        return {
          ...caption,
          seq: Number(caption.seq) + 1
        }
      });


      secondHalf.map((caption, index) => {
        const foundSegment = peaksInstance.segments.getSegment(caption.id!)
        foundSegment && foundSegment.update({
          labelText: `#${Number(caption.seq)} ${((caption.endTime as number) - (caption.startTime as number)).toFixed(1)}s \n\n${caption.caption}`,
        })
      })

      const addedSegment = {
        startTime: (foundSegment.endTime as number) + MINIMUM_CAPTION_GAP,
        endTime: (foundSegment.endTime as number) + MINIMUM_CAPTION_GAP + 0.5,
        editable: true,
        color: '#ffdde5',
        labelText: `새 자막`,
        id: crypto.randomUUID(),
      }

      peaksInstance.segments.add({
        ...addedSegment,
        labelText: `#${firstHalf.length} ${(peaksInstance.player.getCurrentTime() + 1 - peaksInstance.player.getCurrentTime()).toFixed(1)}s \n\n${"새 자막"}`,
      })

      const addedCaption: CaptionListProps = makeAddedCaption(addedSegment, firstHalf)
      firstHalf.push(addedCaption)
      const modifiedCaptionArr = firstHalf.concat(secondHalf)
      setCaptionArr(modifiedCaptionArr)

    } else {

      // 현재 선택중인 자막 없음
      const currentTime = peaksInstance.player.getCurrentTime()
      const foundNextSeg = captionArr.find((caption, index) => {
        return currentTime < (caption.startTime as number)
      });

      if (foundNextSeg) {

        if ((currentTime + MINIMUM_CAPTION_GAP + 0.5 + MINIMUM_CAPTION_GAP) >= (foundNextSeg.startTime as number)) {
          alert('겹침')
          return
        }
      }

      const firstHalf = captionArr.filter((caption, index) => {
        if (Number(caption.endTime) <= currentTime) {
          return true
        } else return false
      })
        .map((caption, index) => {
          return {
            ...caption,
            seq: Number(caption.seq)
          }
        })

      const secondHalf = captionArr.filter((caption, index) => {
        if (currentTime <= Number(caption.startTime)) {
          return true
        } else return false
      }).map((caption, index) => {
        return {
          ...caption,
          seq: Number(caption.seq) + 1
        }
      });

      secondHalf.map((caption, index) => {
        const foundSegment = peaksInstance.segments.getSegment(caption.id!)
        foundSegment && foundSegment.update(
          {
            labelText: `#${Number(caption.seq)} ${((caption.endTime as number) - (caption.startTime as number)).toFixed(1)}s \n\n${caption.caption}`,
          })
      })

      const addedSegment = {
        startTime: peaksInstance.player.getCurrentTime() + MINIMUM_CAPTION_GAP,
        endTime: peaksInstance.player.getCurrentTime() + MINIMUM_CAPTION_GAP + 0.5,
        editable: true,
        color: '#ffdde5',
        labelText: `새 자막`,
        id: crypto.randomUUID(),
      }

      peaksInstance.segments.add({
        ...addedSegment,
        labelText: `#${firstHalf.length} ${(peaksInstance.player.getCurrentTime() + 1 - peaksInstance.player.getCurrentTime()).toFixed(1)}s \n\n${"새 자막"}`,
      })

      const addedCaption: CaptionListProps = makeAddedCaption(addedSegment, firstHalf)
      firstHalf.push(addedCaption)
      const modifiedCaptionArr = firstHalf.concat(secondHalf)
      setCaptionArr(modifiedCaptionArr)
    }

    // window.location.reload() ; 
  }

  const mergeSegment: React.MouseEventHandler<HTMLButtonElement> = e => {

    e.preventDefault()
    if (peaksInstance == null) return

    const {currentTime, foundSegment} = getCurrentSegment(peaksInstance, captionArr);
    const foundIdx = getCurrentSegmentIdx(peaksInstance, captionArr);
    if (foundSegment && foundSegment.id) {
      const nextSegment = captionArr.at(foundIdx + 1)
      if (nextSegment == null) {
        alert('마지막 자막은 병합할 수 없습니다')
        return
      }

      const segmentInPeaksInstance = peaksInstance.segments.getSegment(foundSegment.id!)

      if (segmentInPeaksInstance) {

        const [_1stLine, _2ndLine] = segmentInPeaksInstance.labelText!.split('\n\n')
        const new2ndLine = _2ndLine + ' ' + nextSegment.labelText

        peaksInstance.segments.getSegments().map((segment, index) => {
          if (index > foundIdx) {
            const [_1stLine, _2ndLine] = segment.labelText!.split('\n\n')
            segment.update({
              labelText: `#${index - 1} ${(segment.endTime! - segment.startTime!).toFixed(1)}s \n\n${_2ndLine}`,
            })
          } else if (index === foundIdx) {
            const [_1stLine, _2ndLine] = segment.labelText!.split('\n\n')

            segment.update({
              endTime: Number(nextSegment.endTime),
              labelText: `${_1stLine}\n\n${new2ndLine}`,
            })
          }
        })

        peaksInstance.segments.removeById(nextSegment.id!)

        setCaptionArr(prev => {
          const clonedCaptionArr = structuredClone(prev)

          const filteredCaptionArr = clonedCaptionArr.filter((segment, segmentIndex) => {
            if (segmentIndex === foundIdx + 1) {
              return false
            } else {
              return true
            }
          }).map((segment, segmentIndex) => {
            if (segmentIndex === foundIdx) {
              return {
                ...segment,
                endTime: nextSegment.endTime,
                time_end: secondsToFormattedTime(Number(nextSegment.endTime)),
                labelText: `${new2ndLine}`,
                caption: `${new2ndLine}`,
              }
            } else if (segmentIndex > foundIdx) {
              return {
                ...segment,
                seq: Number(segment.seq) - 1
              }
            }
            return segment
          })

          return filteredCaptionArr
        })
      }
    }
  }

  function isSplitValid(foundSegment: CaptionListProps, currentTime: number) {
    if (Number(foundSegment.endTime) - Number(foundSegment.startTime) < 1.07) {
      alert('1초 이하 자막은 분할할 수 없습니다.')
      return false
    }
    if (Number(foundSegment.endTime) - currentTime < 0.5 + 0.035) {
      alert('후반 자막의 길이는 0.5초 이상이어야 합니다')
      return false
    }
    if (currentTime - Number(foundSegment.startTime) < 0.5 + 0.035) {
      alert('전반 자막의 길이는 0.5초 이상이어야 합니다')
      return false
    }
    return true
  }

  const splitSegment: React.MouseEventHandler<HTMLButtonElement> = e => {

    e.preventDefault()
    if (peaksInstance == null) return

    const {currentTime, foundSegment} = getCurrentSegment(peaksInstance, captionArr);
    const foundIdx = getCurrentSegmentIdx(peaksInstance, captionArr);

    if (foundSegment && foundSegment.id) {

      const endTime = Number(foundSegment.endTime)
      const startTime = Number(foundSegment.startTime)
      const segmentDuration = endTime - startTime - MINIMUM_CAPTION_GAP;
      const firstHalfRatio = (currentTime - 0.035 - startTime) / segmentDuration
      const secondhalfRatio = (endTime - currentTime - 0.035) / segmentDuration

      if (!isSplitValid(foundSegment, currentTime)) {
        return
      }

      const wordsArr = foundSegment.labelText!.split("\n\n").at(-1)!.split(" ")!
      const firstHalfLastIndex = Math.floor(wordsArr.length * firstHalfRatio)
      const secondHalfLastIndex = Math.floor(wordsArr.length * secondhalfRatio)
      const _1stHalfWords = wordsArr.slice(0, firstHalfLastIndex + 1).join(" ")

      const _2ndHalfWords = wordsArr.slice(firstHalfLastIndex + 1).join(" ")

      const segmentInPeaksInstance = peaksInstance.segments.getSegment(foundSegment.id)
      const [caption1stLine, caption2ndLine] = segmentInPeaksInstance!.labelText!.split("\n\n")
      const [no, time] = caption1stLine.split(" ")

      segmentInPeaksInstance?.update({
        endTime: currentTime - 0.035,
        labelText: `${no} ${(currentTime - (segmentInPeaksInstance.startTime as number) - 0.035).toFixed(1)}s \n\n${_1stHalfWords}`,
      })

      const addedSegment = {
        startTime: currentTime + 0.035,
        endTime: foundSegment.endTime as number,
        editable: true,
        color: '#ffdde5',
        id: crypto.randomUUID(),
        labelText: `${_2ndHalfWords}`,
      }

      peaksInstance.segments.add({
        ...addedSegment,
        labelText: `#${foundSegment.seq + 1} ${((foundSegment.endTime as number) - currentTime + 0.035).toFixed(1)}s \n\n${_2ndHalfWords}`,
      })

      const firstHalfRaw = captionArr.slice(0, foundIdx + 1)

      const firstHalf = firstHalfRaw.map((caption, index) => {
        if (index === firstHalfRaw.length - 1) {
          return {
            ...caption,
            endTime: currentTime - 0.035,
            time_end: secondsToFormattedTime(currentTime - 0.035),
            caption: _1stHalfWords,
            labelText: _1stHalfWords,
          }
        } else {
          return {
            ...caption,
          }
        }
      })

      const secondHalf = captionArr.slice(foundIdx + 1).map((caption, index) => {
        return {
          ...caption,
          seq: Number(caption.seq) + 1
        }
      })


      secondHalf.map((segment, index) => {
        const segmentInPeaksInstance = peaksInstance.segments.getSegment(segment.id!)
        segmentInPeaksInstance?.update(
          {
            labelText: `#${segment.seq} ${((segment.endTime as number) - (segment.startTime as number)).toFixed(1)}s \n\n${segment.caption}`
          })
      })

      peaksInstance.segments.getSegments().sort((a, b) => a.startTime - b.startTime)


      const addedCaption: CaptionListProps = makeAddedCaption(addedSegment, firstHalf)
      firstHalf.push(addedCaption)
      const modifiedCaptionArr = firstHalf.concat(secondHalf)
      setCaptionArr(modifiedCaptionArr)
    } else {
      alert("분할할 자막을 선택해 주세요")
    }
  }

  const deleteSegment = () => {

    if (peaksInstance == null) return

    const {foundSegment} = getCurrentSegment(peaksInstance, captionArr);
    const foundSegmentIdx = getCurrentSegmentIdx(peaksInstance, captionArr);


    if (foundSegment && foundSegment.id) {

      peaksInstance.segments.removeById(foundSegment.id)

      const {secondHalf, firstHalf} = deleteAndSplitSegments(captionArr, foundSegmentIdx, setCaptionArr);

      secondHalf.map((segment, index) => {
        const segmentInPeaksInstance = peaksInstance.segments.getSegment(segment.id!)
        segmentInPeaksInstance?.update({
          labelText: `#${segment.seq} ${((segment.endTime as number) - (segment.startTime as number)).toFixed(1)}s \n\n${segment.caption}`
        })
      })

    } else {
      alert("삭제할 자막을 선택해 주세요")
    }
  }

  const onDeleteSegment: React.MouseEventHandler<HTMLButtonElement> = e => {
    e.preventDefault()
    deleteSegment();
  }

  function Buttons() {
    return <>
      <div className="" style={{display: "flex",}}>
        <div className="" style={{
          margin: "2.5px",
          display: "flex",
          flexDirection: "row",
          gap: "0px",
          width: "100%",
          marginLeft: "2em"
        }}>
          <button type="button" className="btn_split" onClick={addSegment}>추가</button>
          <button type="button" className="btn_split" onClick={splitSegment}>분할</button>
          <button type="button" className="btn_split" onClick={mergeSegment}>병합</button>
          <button type="button" className="btn_split" onClick={onDeleteSegment}>삭제</button>
          <input type="checkbox"
                 id='captionSelectMode'
                 defaultChecked={globalThis.isAutoCaptionHighlight != null ? globalThis.isAutoCaptionHighlight : globalThis.isAutoCaptionHighlight = false}
                //  onLoad={e => globalThis.isAutoCaptionHighlight = e.target}
                 onChange={e => {
                  globalThis.isAutoCaptionHighlight = e.target.checked;
                  setIsAutoCaptionHighlight(e.target.checked)
                }
                }
          />
          <label htmlFor="captionSelectMode">
              자막 선택 on/off
          </label>
        </div>
        <div className=""
             style={{margin: "2.5px", display: "flex", flexDirection: "row", gap: "0px", marginRight: "2em"}}>
          <button type="button" className="btn_split" onClick={zoomIn}>Zoom In</button>
          <button type="button" className="btn_split" onClick={zoomOut}>Zoom Out</button>
        </div>
      </div>
    </>;
  }

  return (
    <>
      {mp3Url.length > 0 &&
        <div className="Peaks">
          <Buttons/>
          {/* <div className="" style={{margin : "2.5px", display : "flex", flexDirection : "row", gap :"0px", width : "100%"}}>
              </div>                */}
          <div id="zoomview-container" style={{width: "100%", height: "160px"}} ref={zoomviewWaveformRef}></div>
          <div id="scrollbar-container" style={{width: "100%", height: "10px"}}></div>
          <audio style={{
            visibility: "hidden",
            width: "100%",
            height: "30px",
            margin: "0px",
            display: "flex",
            flexDirection: "column",
            gap: "0px"
          }}
            ref={audioElementRef} controls={true}>
            <source src={mp3Url}
                    type={"audio/mpeg"}
            />
          </audio>
        </div>
      }
    </>
  )

}

export default PeaksComponent

function deleteAndSplitSegments(captionArr: CaptionListProps[], foundSegmentIdx: number, setCaptionArr: React.Dispatch<React.SetStateAction<CaptionListProps[]>>) {
  const firstHalf = captionArr.slice(0, foundSegmentIdx);
  const secondHalf = captionArr.slice(foundSegmentIdx + 1).map((caption, index) => {
    return {
      ...caption,
      seq: Number(caption.seq) - 1
    };
  });
  const newSegments = firstHalf.concat(secondHalf)
  setCaptionArr(newSegments)
  return {secondHalf, firstHalf};

}

function getCurrentSegmentIdx(peaksInstance: PeaksInstance, captionArr: CaptionListProps[]) {
  const currentTime = peaksInstance.player.getCurrentTime();

  const findCurrentSegmentIdx = (caption: CaptionListProps, index: number) => {
    if (Number(caption.startTime) <= currentTime
      && Number(caption.endTime) >= currentTime) {
      return true;
    } else
      return false;
  };

  const foundSegmentIdx = captionArr.findIndex(findCurrentSegmentIdx);
  return foundSegmentIdx;
}

function getCurrentSegment(peaksInstance: PeaksInstance, captionArr: CaptionListProps[]) {
  const currentTime = peaksInstance.player.getCurrentTime();

  const findCurrentSegment = (caption: CaptionListProps, index: number) => {
    if (Number(caption.startTime) <= currentTime && Number(caption.endTime) >= currentTime) {
      return true;
    } else
      return false;
  };
  const foundSegment = captionArr.find(findCurrentSegment);
  return {currentTime, foundSegment};
}


function makeAddedCaption(addedSegment: { startTime: number; endTime: number; editable: boolean; color: string; labelText: string; id: string; }, firstHalf: { seq: number; time_ini: string; time_end: string; caption: string; startTime?: Number | undefined; endTime?: Number | undefined; labelText?: string | undefined; color?: string | undefined; id?: string | undefined; editable?: Boolean | undefined; }[]): CaptionListProps {
  return {
    caption: addedSegment.labelText,
    color: addedSegment.color,
    editable: addedSegment.editable,
    labelText: addedSegment.labelText,
    id: addedSegment.id,
    endTime: addedSegment.endTime,
    startTime: addedSegment.startTime,
    seq: firstHalf.length,
    time_end: secondsToFormattedTime(addedSegment.endTime).replace(".", ","),
    time_ini: secondsToFormattedTime(addedSegment.startTime).replace(".", ","),
  };
}
